<template>
    <div class="flex flex-wrap" id="admJimsTT">
        <div class="w-full bg-tan-200 px-4 pt-2 border border-gray-200 border-b-0" :class="{'border-b pb-2': dataLoading.section }" v-if="isAdd">
            <label for="section">Type and Market / Contract / Symbol</label>
            <select class="form-control form-control-fixed form-input-modal mt-2" v-model="section" name="section" id="section">
                <option value="future">Futures</option>
                <option value="forex">Forex</option>
                <option value="future-spreads">Future Spreads</option>
                <option value="future-options">Options</option>
                <option value="stock-etf">Stocks & ETFs</option>
            </select>
        </div>

        <div v-if="!dataLoading.section" class="w-full">
            <div class="w-full bg-tan-200 px-4 pb-2 border mb-4 border-gray-200 border-t-0" v-if="isAdd">
                <div v-if="section === 'future'">
                    <div class="selector-wrapper">
                        <contract-selector
                            v-model="form.symbol"
                            :initial="sectionQuotes.symbol"
                            :all-contracts="sectionQuotes.futures">
                        </contract-selector>
                    </div>
                </div>

                <div v-if="section === 'forex'">
                    <div class="selector-wrapper">
                        <forex-selector
                            v-model="form.symbol"
                            default-symbol="^AUDJPY"
                            :symbols="sectionQuotes.forex">
                        </forex-selector>
                    </div>
                </div>

                <div v-if="section === 'future-spreads'">
                    <div class="selector-wrapper" id="selectFutureSpreads">
                        <spread-selector
                            :spreads="sectionQuotes.spreads"
                            :all-contracts="sectionQuotes.futures"
                            v-model="form.symbol"
                            >
                        </spread-selector>
                    </div>
                </div>

                <div v-if="section === 'future-options'">
                    <div class="selector-wrapper" id="selectFutureOptions">
                        <option-selector-2
                            v-model="form.symbol"
                            :initial-symbol="sectionQuotes.underlying"
                            :groups="sectionQuotes.options || sectionQuotes"
                            >
                        </option-selector-2>
                    </div>
                </div>

                <div v-if="section === 'stock-etf'" class="relative">
                    <div class="selector-wrapper">
                        <stock-search-selector
                            v-model="form.symbol">
                        </stock-search-selector>
                    </div>
                </div>
            </div>

            <div class="w-full border px-6 py-2 mb-4 bg-gray-super-100 text-center" v-show="!dataLoading.section && form.symbol">
                <div class="w-full mb-2" v-if="!isAdd">
                    <strong>Trade ID #{{ form.id }}</strong>
                </div>
                <span v-if="!dataLoading.symbolQuotes">
                    <p class="text-md leading-none mb-1 font-bold text-blue-500">{{ symbolQuotes.contractFullName || symbolQuotes.symbolName }}</p>
                    <p class="text-sm font-bold leading-none">Last Price: {{ symbolQuotes.lastPrice }}</p>
                </span>
                <spinner class="-my-1" v-else></spinner>
            </div>
            <div v-if="errors.symbol" class="error">
                {{ errors.symbol[0] }}
            </div>

            <template v-if="!dataLoading.symbolQuotes">
                <div class="w-full bg-tan-200 border border-tan-500 p-3">
                    <div class="w-full">
                        <label for="direction">Is Trade Tracker Alert - Public?</label>
                        <toggle-switch class="ml-2" :value="form.public" :clickable="true" v-model="form.public"></toggle-switch>
                    </div>
                </div>

                <div class="flex flex-wrap mt-2 mb-2">
                    <div class="xs:w-full sm:w-1/2 md:w-1/4 pr-2 xs:pr-0">
                        <label for="category">Trade Tracker's Category:</label>
                        <select class="form-control form-control-sm form-input-modal" v-model="form.category_id" name="category" id="category">
                            <template v-for="category in pasCategories">
                            <option :value="category.id" v-if="category.active">{{ category.name }}</option>
                            </template>
                            <option value="">&plus; Create new Category...</option>
                        </select>
                    </div>
                    <div class="xs:w-full sm:w-1/2 md:w-1/4 pr-1 xs:pr-0 xs:mt-1 mt-0" v-if="!form.category_id">
                        <label for="custom-category">New Category Name:</label>
                        <input :class="{ 'is-invalid' : !form.category_id && errors.category_id }" class="form-input form-input-sm" type="text" v-model="form.custom_category" maxlength="30" placeholder="Enter a new category name...">
                        <div v-if="!form.category_id && errors.category_id" class="error">
                            {{ errors.category_id[0] }}
                        </div>
                    </div>
                </div>
                <div class="flex flex-wrap mt-2 mb-2">
                    <div class="xs:w-full w-1/4 pr-2 xs:pr-0">
                        <label for="quantity">Quantity</label>
                        <input :class="{ 'is-invalid' : errors.quantity }" class="form-input form-input-sm" type="number" v-model.number="form.quantity">
                        <div v-if="errors.quantity" class="error">
                            {{ errors.quantity[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/4 pr-1 xs:pr-0">
                        <label for="direction">Market Direction:</label>
                        <select :class="{ 'is-invalid' : errors.direction }" class="form-control form-control-sm form-input-modal" v-model="form.direction" name="direction" id="direction">
                            <option value="U">Up</option>
                            <option value="D">Down</option>
                            <option value="N">Neutral</option>
                        </select>
                        <div v-if="errors.direction" class="error">
                            {{ errors.direction[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/4 pl-1 xs:pl-0">
                        <label for="pattern">Chart Pattern</label>
                        <input :class="{ 'is-invalid' : errors.pattern }" class="form-input form-input-sm" type="text" v-model="form.pattern">
                        <div v-if="errors.pattern" class="error">
                            {{ errors.pattern[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/4 pl-2 xs:pl-0">
                        <label for="strategy">Strategy</label>
                        <select :class="{ 'is-invalid' : errors.strategy }" v-model="form.strategy" class="form-control form-control-sm form-input-modal" id="strategy">
                            <template v-if='strategyType == "future"'>
                            <option value="Long">Long</option>
                            <option value="Short">Short</option>
                            </template>
                            <template v-else>
                            <option value="Buy">Buy</option>
                            <option value="Sell">Sell</option>
                            </template>
                        </select>
                        <div v-if="errors.strategy" class="error">
                            {{ errors.strategy[0] }}
                        </div>
                    </div>
                </div>

                <div class="flex flex-wrap mb-2">
                    <div class="xs:w-full w-1/4 pr-2 xs:pr-0">
                        <label for="entry_date">Entry Date</label>
                        <input :class="{ 'is-invalid' : errors.entry_date }" class="form-input" type="date" v-model="form.entry_date" pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}">
                        <div v-if="errors.entry_date" class="error">
                            {{ errors.entry_date[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/4 pr-2 xs:pr-0">
                        <label for="entry_price">Entry Price</label>
                        <price-input :symbol="form.symbol" v-model="form.entry_price" :base-code="symbolQuotes.baseCode" :default-value="form.entry_price" :class="{'is-invalid': errors.entry_price == true}" id="entry_price" class="form-input form-input-sm form-input-modal"></price-input>
                        <div v-if="errors.entry_price" class="error">
                            {{ errors.entry_price[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/4 pr-2 xs:pr-0">
                        <label for="exit_date">Exit Date</label>
                        <input class="form-input" type="date" v-model="form.exit_date" pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}">
                    </div>
                    <div class="xs:w-full w-1/4">
                        <label for="expiration_date">Expiration Date</label>
                        <input class="form-input" type="date" v-model="form.expiration_date" pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}">
                    </div>
                </div>
                <div class="flex flex-wrap mb-2">
                    <div class="xs:w-full w-1/3 pr-2 xs:pr-0">
                        <label for="stop_loss">Stop Loss</label>
                        <price-input :symbol="form.symbol" v-model="form.stop_loss" :base-code="symbolQuotes.baseCode" :default-value="form.stop_loss" :class="{'is-invalid': errors.stop_loss == true}" id="stop_loss" class="form-input form-input-sm form-input-modal"></price-input>
                        <!-- <input :class="{ 'is-invalid' : errors.stop_loss }" class="form-input form-input-sm" type="text" v-model="form.stop_loss" id="stop_loss"> -->
                        <!-- <price-input v-model="form.stop_loss" :base-code="symbolQuotes.baseCode" :default-value="form.stop_loss" :class="{'is-invalid': errors.stop_loss == true}" id="stop_loss" :disabled="form.exit_date != '' && isDisabled(form.target_price)" class="form-input form-input-sm form-input-modal"></price-input> -->
                        <div v-if="errors.stop_loss" class="error">
                            {{ errors.stop_loss[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/3 pr-2 xs:pr-0">
                        <label for="target_price">Target Price</label>
                        <price-input :symbol="form.symbol" v-model="form.target_price" :base-code="symbolQuotes.baseCode" :default-value="form.target_price" :class="{'is-invalid': errors.target_price == true}" id="target_price" class="form-input form-input-sm form-input-modal"></price-input>
                        <!-- <input :class="{ 'is-invalid' : errors.target_price }" class="form-input form-input-sm" type="text" v-model="form.target_price" id="target_price"> -->
                        <!-- <price-input v-model="form.target_price" :base-code="symbolQuotes.baseCode" :default-value="form.target_price" :class="{'is-invalid': errors.target_price == true}" id="target_price" :disabled="form.exit_date != '' && isDisabled(form.stop_loss)" class="form-input form-input-sm form-input-modal"></price-input> -->
                        <div v-if="errors.target_price" class="error">
                            {{ errors.target_price[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/3">
                        <label for="closed_profit_loss">Actual Exit Price</label>
                        <price-input :symbol="form.symbol" v-model="form.exit_price" :base-code="symbolQuotes.baseCode" :default-value="form.exit_price" :class="{'is-invalid': errors.exit_price == true}" id="exit_price" class="form-input form-input-sm form-input-modal"></price-input>
                        <!-- <input :class="{ 'is-invalid' : errors.exit_price }" class="form-input form-input-sm" type="text" v-model="form.exit_price" id="exit_price"> -->
                        <div v-if="errors.exit_price" class="error">
                            {{ errors.exit_price[0] }}
                        </div>
                    </div>
                </div>

                <div class="flex flex-wrap mb-2">
                    <div class="xs:w-full w-1/3 pr-2 xs:pr-0">
                        <label for="current_price">Current Price</label>
                        <price-input :symbol="form.symbol" v-model="form.current_price" :base-code="symbolQuotes.baseCode" :default-value="form.current_price" :class="{'is-invalid': errors.current_price == true}" id="current_price" class="form-input form-input-sm form-input-modal"></price-input>
                        <div v-if="errors.current_price" class="error">
                            {{ errors.current_price[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/3 pr-2 xs:pr-0">
                        <label for="profit_loss">Profit/Loss</label>
                        <input class="form-input form-input-sm" :class="{'form-input-up' : profitLoss > 0, 'form-input-down' : profitLoss < 0}" type="number" v-model="profitLoss" disabled>
                    </div>
                    <div class="xs:w-full w-1/3">
                        <label for="closed_profit_loss">Closed Out Profit/Loss</label>
                        <input class="form-input form-input-sm" :class="{'form-input-up' : closedProfitLoss > 0, 'form-input-down' : closedProfitLoss < 0}" type="number" v-model="closedProfitLoss" disabled>
                    </div>
                </div>

                <div class="w-full my-4 border">
                    <div class="flex flex-wrap items-center bg-gray-super-100 border-b">
                        <div class="inline-block px-4 py-2 font-bold text-sm">Trade Tracker Video</div>
                    </div>
                    <div class="w-full bg-white px-4 py-2">
                        <div class="w-full">
                            <label for="videoRefInput">
                                <template v-if="video">
                                    Choose File to REPLACE current video <a :href="getVideoLink(form.video_id)" target="_blank">ID#{{ form.video_id }}</a>
                                </template>
                                <template v-else>Choose File to upload</template>
                            </label>
                            <input type="file" id="videoRefinput" ref="videoRef" class="form-input form-input-sm" @change="onSelectFileUpload()" />
                        </div>
                        <div class="w-full">
                            <label for="videoTitle">
                                Title
                                <input id="videoTitle" class="form-input form-input-sm" :class="{'is-invalid': errors.video_title}" type="text" v-model="form.videoTitle">
                            </label>
                            <div v-if="errors.video_title" class="error">
                                {{ errors.video_title }}
                            </div>
                        </div>
                        <div class="w-full">
                            <label for="videoTitle">
                                Description
                                <input id="videoTitle" class="form-input form-input-sm" :class="{'is-invalid': errors.video_description}" type="text" v-model="form.videoDescription">
                            </label>
                            <div v-if="errors.video_description" class="error">
                                {{ errors.video_description }}
                            </div>
                        </div>
                        <div class="w-full" v-if="form.video_id">
                            <label for="removeFile">
                                <input class="mb-1" type="checkbox" :value="false" v-model="videoRemove" id="removeFile">
                                <label for="removeFile">Delete Trade Tracker Video</label>
                            </label>
                            <p class="text-sm font-italic text-gray-500 mt-1">Note: Replacing or deleting a video will remove it from S3</p>
                        </div>
                    </div>
                </div>

                <div class="w-full mb-4">
                    <div class="flex flex-wrap items-center mt-4 bg-tan-200 border border-b-0">
                        <div class="inline-block px-4 py-2 font-bold text-base"><i class="fas fa-list mr-2"></i>Market Notes</div>
                        <div class="inline-block ml-auto pr-4">
                            <span @click="addNote()" class="btn btn-xs btn-blue btn-shadow-none"><i class="fas fa-plus"></i><b class="ml-1">Add a new Market Note</b></span>
                        </div>
                    </div>
                    <table class="table table-hover border border-t-0 admin-table">
                        <thead>
                            <tr class="bg-gray-super-100">
                                <th>Notes</th>
                                <th class="text-center">Posted</th>
                                <th class="text-center">Public</th>
                                <th class="text-center">Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(note, index) in form.notes" :class="{'border-t-0' : index > 0}" :key="index">
                            <tr>
                                <td class="w-2/3">
                                    <div class="w-full block -mx-3 -my-1">
                                        <textarea id="description" class="form-input form-input-sm form-control-no-shadow adm-jtt-notes-area" rows="4" v-model="note.description"></textarea>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <input :id="`date-` + index" type="date" class="form-input-inline-w-none w-auto" :class="{'is-invalid': !note.date }" v-model="note.date">
                                </td>
                                <td class="text-center">
                                    <toggle-switch class="ml-2 tgl-dark" :value="note.public" :clickable="true" v-model="note.public"></toggle-switch>
                                </td>
                                <td class="text-center">
                                    <span @click="removeNote(index)" class="btn btn-red btn-xs inline-block ml-auto">
                                        <i class="fa fa-times cursor-pointer"></i>
                                    </span>
                                </td>
                            </tr>
                            </template>
                        </tbody>
                    </table>
                </div>

                <div class="w-full mt-2 mb-2 text-sm">
                    <label for="sendNotifications">
                        <input class="mb-1 mr-1" type="checkbox" :value="true" v-model="form.sendNotifications" id="sendNotifications" />
                        Send Notifications to Users
                    </label>
                </div>

                <hr />

                <spinner v-if="dataLoading.updating"></spinner>
                <div class="w-full mt-8 flex flex-wrap">
                    <button @click="onPreviewNotification" class="btn btn-blue mr-1">Preview Notification</button>
                    <template v-if="!dataLoading.updating">
                        <template v-if="isAdd">
                            <button @click="handleOnAdd" class="btn btn-yellow">Add</button>
                        </template>
                        <template v-else>
                            <button @click="handleOnUpdate" class="btn btn-yellow">Update</button>
                            <!-- <button @click="onClose" class="btn btn-blue-400 ml-1">Close Alert</button> -->
                        </template>
                    </template>
                    <a href="/admin/jims-trade-tracker/" class="text-black ml-2 btn btn-default">Cancel</a>
                    <button @click="onDelete" class="btn btn-red ml-auto" v-if="!isAdd">Delete</button>
                </div>

            </template>
        </div>
        <spinner v-else></spinner>

        <flash-message ref="flash"></flash-message>

    </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue';

import PriceInput from '../PriceInput';
import ToggleSwitch from '../Elements/ToggleSwitch';

const props = defineProps({
    initialValues: {
        type: Object,
        default: () => ({}),
        required: false
    },
    pasCategories: {
        type: [Object, Array],
        required: false
    },
});

const $clone = (obj) => JSON.parse(JSON.stringify(obj));

const flash = ref(null);
const isAdd = ref(Object.keys(props.initialValues).length === 0);
const section = ref(props.initialValues.section || 'future');

const sectionQuotes = ref([]);
const symbolQuotes = ref({});

const dataLoading = ref({
    updating: false,
    section: props.initialValues.symbol ? false : true,
    symbolQuotes: props.initialValues.symbol ? true : false,
});

const video = ref(props.initialValues.video || null);
const videoRef = ref(null);
const videoRefValue = ref('');
const videoChanged = ref(false);
const videoRemove = ref(false);

const form = ref({
    id: props.initialValues.id || null,
    category_id: props.initialValues.category_id || props.pasCategories[0].id,
    custom_category: '',
    symbol: props.initialValues.symbol || null,
    contract_name: props.initialValues.contract_name || null,
    direction: props.initialValues.direction || 'U',
    pattern: props.initialValues.pattern || null,
    strategy: props.initialValues.strategy || 'Long',
    quantity: props.initialValues.quantity || null,
    entry_price: props.initialValues.entry_price || null,
    entry_date: toDateString(props.initialValues.entry_date) || toDateString(new Date()),
    closed_profit_loss: props.initialValues.closed_profit_loss || null,
    stop_loss: props.initialValues.stop_loss || '',
    target_price: props.initialValues.target_price || '',
    exit_date: toDateString(props.initialValues.exit_date),
    exit_price: props.initialValues.exit_price || '',
    expiration_date: toDateString(props.initialValues.expiration_date),
    notes: orderedByDate(props.initialValues.notes || []),
    public: (props.initialValues.public ? true : false) || false,
    video_id: props.initialValues.video_id || null,
    unit_code: null,
    current_price: null,
    sendNotifications: false,
    videoTitle: props.initialValues.video?.title || '',
    videoDescription: props.initialValues.video?.description || '',
});

const errors = ref({});

const strategyType = computed(() => {
    if (props.initialValues.strategy) {
        return (props.initialValues.strategy === 'Buy' || props.initialValues.strategy === 'Sell') ? 'other' : 'future';
    } else {
        return (section.value === 'future') ? 'future' : 'other';
    }
});

const profitLoss = computed(() => {
    let profitLoss = '';
    if (symbolQuotes.value.raw) {
        // Assuming isNumber is a method you've defined
        if (form.value.exit_date === '' && isNumber(form.value.quantity) && isNumber(form.value.entry_price) && isNumber(form.value.current_price)) {
            let pointValue = symbolQuotes.value.raw.pointValue || 1;
            if (symbolQuotes.value.raw.symbolType === 10) {
                pointValue = Math.pow(10, symbolQuotes.value.raw.unitCode);
            }
            if (form.value.strategy === 'Long' || form.value.strategy === 'Buy') {
                profitLoss = ((form.value.current_price - form.value.entry_price) * form.value.quantity * pointValue).toFixed(2);
            } else if (form.value.strategy === 'Short' || form.value.strategy === 'Sell') {
                profitLoss = ((form.value.entry_price - form.value.current_price) * form.value.quantity * pointValue).toFixed(2);
            }
        }
    }
    return profitLoss;
});

const closedProfitLoss = computed(() => {
    let closedProfitLoss = '';
    if (symbolQuotes.value.raw) {
        let closedPrice = 0;
        if (isNumber(form.value.exit_price)) {
            closedPrice = form.value.exit_price;
        } else if (isNumber(form.value.stop_loss) && isNumber(form.value.target_price)) {
            closedPrice = 0;
        } else {
            closedPrice = form.value.stop_loss || form.value.target_price;
        }

        if (form.value.exit_date !== '' && isNumber(form.value.quantity) && isNumber(form.value.entry_price) && closedPrice) {
            let pointValue = symbolQuotes.value.raw.pointValue || 1;
            if (symbolQuotes.value.raw.symbolType === 10) {
                pointValue = Math.pow(10, symbolQuotes.value.raw.unitCode);
            }
            if (form.value.strategy === 'Long' || form.value.strategy === 'Buy') {
                closedProfitLoss = ((closedPrice - form.value.entry_price) * form.value.quantity * pointValue).toFixed(2);
            } else if (form.value.strategy === 'Short' || form.value.strategy === 'Sell') {
                closedProfitLoss = ((form.value.entry_price - closedPrice) * form.value.quantity * pointValue).toFixed(2);
            }
        }
    }
    return closedProfitLoss;
});

function onSelectFileUpload() {
    videoRefValue.value = videoRef.value.files[0];
    videoChanged.value = true;
}

function getVideoLink(videoId) {
    return window.location.origin + '/videos/' + videoId;
}

function orderedByDate(items) {
    return items.sort((a, b) => new Date(b.date) - new Date(a.date));
}

function isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
}

function toDateString(strValue) {
    if (!strValue) {
        return '';
    }
    var date = new Date(strValue).toISOString();
    return date.split('T')[0];
}

function isDisabled(dValue) {
    return (dValue && dValue !== '') ? true : false;
}

function addNote() {
    form.value.notes.push({
        description: '',
        date: (new Date).toISOString().split('T')[0],
        public: false
    });
}

function removeNote(rIndex) {
    form.value.notes.splice(rIndex, 1);
}

function convertModelToFormData(pModel, pForm, pNamespace = '') {
    let formData = pForm || new FormData();

    for (let propertyName in pModel) {
        if (!pModel.hasOwnProperty(propertyName) || !pModel[propertyName]) {
            continue;
        }
        let formKey = pNamespace ? `${pNamespace}[${propertyName}]` : propertyName;
        if (pModel[propertyName] instanceof Date) {
            formData.append(formKey, pModel[propertyName].toISOString());
        } else if (pModel[propertyName] instanceof Array) {
            pModel[propertyName].forEach((element, index) => {
                const tempFormKey = `${formKey}[${index}]`;
                convertModelToFormData(element, formData, tempFormKey);
            });
        } else if (typeof pModel[propertyName] === 'object' && !(pModel[propertyName] instanceof File)) {
            convertModelToFormData(pModel[propertyName], formData, formKey);
        } else {
            formData.append(formKey, pModel[propertyName].toString());
        }
    }
    return formData;
}

function isValidateForm() {
    if (videoRefValue.value) {
        if (!form.value.videoTitle) {
            errors.value.video_title = 'The video title is required.';
        } else {
            errors.value.video_title = false;
        }

        if (!form.value.videoDescription) {
            errors.value.video_description = 'The video description is required.';
        } else {
            errors.value.video_description = false;
        }
        return !(errors.value.video_title || errors.value.video_description);
    }
    if (form.value.notes && form.value.notes.length) {
        let found = form.value.notes.find(n => { return n.date == '' });
        return !found;
    }
    return true;
}

function handleOnAdd() {
    if (!isValidateForm()) {
        flash.value.error('Error! Please correct the errors highlighted below and try again');
        return;
    }

    dataLoading.value.updating = true;

    // create a new entry
    var formData = new FormData();
    formData.append('file', videoRefValue.value);

    let data = $clone(form.value);
    if (!data.category_id) {
        data.category_id = '';
    }

    // filter notes (remove empty ones) and sort by date
    let notes = data.notes.filter(n => (n.description && n.date));
    data.notes = orderedByDate(notes);
    convertModelToFormData(data, formData);

    // fixed the 'public' flag
    formData.set('public', form.value.public ? 'true' : 'false');

    const route = window.route('admin.jims-trade-tracker.store');
    errors.value = {};
    axios.post(route, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((response) => {
            window.location = window.route('admin.jims-trade-tracker.index');
        }).catch(error => {
            flash.value.error('Error creating «Jim\'s Trade Tracker» entry');
            errors.value = error.response.data.errors;
        }).then(() => {
            dataLoading.value.updating = false;
        });
}

function handleOnUpdate() {
    if (!isValidateForm()) {
        flash.value.error('Error! Please correct the errors highlighted below and try again');
        return;
    }

    dataLoading.value.updating = true;

    // update entry
    var formData = new FormData();
    formData.append('_method', 'PUT');
    formData.append('file', videoRefValue.value);
    formData.append('videoChanged', videoChanged.value);
    formData.append('videoRemove', videoRemove.value);

    let data = $clone(form.value);
    if (!data.category_id) {
        data.category_id = '';
    }

    // filter notes (remove empty ones) and sort by date
    let notes = data.notes.filter(n => (n.description && n.date));
    data.notes = orderedByDate(notes);
    convertModelToFormData(data, formData);

    // fixed the 'public' flag
    formData.set('public', form.value.public ? 'true' : 'false');

    const route = window.route('admin.jims-trade-tracker.update', { jims_trade_tracker: form.value.id });
    errors.value = {};
    axios.post(route, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((response) => {
            window.location = window.route('admin.jims-trade-tracker.index');
        }).catch(error => {
            flash.value.error('Error saving «Jim\'s Trade Tracker» entry');
            errors.value = error.response.data.errors;
        }).then(() => {
            dataLoading.value.updating = false;
        });
}

// function nClose() {
// 	// close entry
// 	const route = window.route('admin.jims-trade-tracker.close', { jims_trade_tracker: form.value.id });
// 	axios.patch(route, { jims_trade_tracker: form.value.id })
// 		.then((response) => {
// 			window.location = window.route('admin.jims-trade-tracker.index');
// 		}).catch(error => {
// 			flash.value.error('Error closing «Jim\'s Trade Tracker» entry');
// 		}).then(() => {
// 		});
// }

function onDelete() {
    // delete entry
    const route = window.route('admin.jims-trade-tracker.destroy', { jims_trade_tracker: form.value.id });
    axios.delete(route, { jims_trade_tracker: form.value.id })
        .then((response) => {
            window.location = window.route('admin.jims-trade-tracker.index');
        }).catch(error => {
            flash.value.error('Error deleting «Jim\'s Trade Tracker» entry');
        });
}

function onPreviewNotification() {
    var formData = JSON.parse(JSON.stringify(form.value));
    if (!formData.category_id) {
        formData.category_id = '';
    }

    const route = window.route('admin.jims-trade-tracker.preview');
    errors.value = {};
    axios.post(route, formData)
        .then((response) => {
            var w = window.open('about:blank', 'preview' + new Date());
            w.document.write(response.data);
            w.document.close();
            w.focus();
        }).catch(error => {
            flash.value.error('Error creating «Jim\'s Trade Tracker» entry');
            errors.value = error.response.data.errors;
        }).then(() => {
        });
}

// function onSendNotification() {
//     form.value.sendNotifications = true;
//     if (isAdd.value) {
//         handleOnAdd();
//     } else {
//         handleOnUpdate();
//     }
// }

function getSymbolSelectQuotes() {
    const route = window.route('api.quotes.symbol-select');

    dataLoading.value.section = true;

    axios.post(route, { section: section.value })
        .then((response) => {
            sectionQuotes.value = response.data;
        }).catch(error => {
            console.error(error);
        }).then(() => {
            dataLoading.value.section = false;
        });
}

function getSymbolQuotes() {
    const route = window.route('api.quotes');

    dataLoading.value.symbolQuotes = true;

    const params = {
        symbol: form.value.symbol,
        fields: 'baseCode,symbol,symbolType,symbolName,contractFullName,contractMonthYear,lastPrice,tradeTime,contractExpirationDate,pointValue,unitCode',
        raw: true,
        after: 'getChartTitle'
    };

    axios.post(route, params)
        .then((response) => {
            symbolQuotes.value = response.data.data[0];
            form.value.unit_code = symbolQuotes.value.unitCode;

            if (isAdd.value) {
                form.value.contract_name = symbolQuotes.value.contractFullName;
                form.value.expiration_date = (symbolQuotes.value.contractExpirationDate && symbolQuotes.value.contractExpirationDate != 'N/A') ? toDateString(symbolQuotes.value.contractExpirationDate) : '';
            }
        }).catch(error => {
            console.error(error);
        }).then(() => {
            dataLoading.value.symbolQuotes = false;
        });
}

watch(closedProfitLoss, (closedProfitLossValue) => {
    form.value.closed_profit_loss = closedProfitLossValue;
}, { immediate: true });

watch(() => symbolQuotes.value.raw?.lastPrice, (newLastPrice) => {
    if (newLastPrice !== undefined) {
        form.value.current_price = newLastPrice;
    }
});

// watch(() => form.value.exit_date, (newValue) => {
//     if (newValue != '' & isNumber(form.value.stop_loss) && isNumber(form.value.target_price)) {
//         form.value.stop_loss = '';
//         form.value.target_price = '';
//     }
// });

watch(() => form.value.symbol, (newSymbol) => {
    if (newSymbol) {
        getSymbolQuotes();
    }
});

watch(() => form.value.videoTitle, () => {
    videoChanged.value = true;
});

watch(() => form.value.videoDescription, () => {
    videoChanged.value = true;
});

watch(section, () => {
    if (isAdd.value) {
        form.value.symbol = '';
        form.value.current_price = null;
        form.value.strategy = strategyType.value === 'future' ? 'Long' : 'Buy';
    }
    getSymbolSelectQuotes();
});

onMounted(() => {
    if (form.value.symbol) {
        getSymbolQuotes();
    } else {
        getSymbolSelectQuotes();
    }
});
</script>

<style lang="scss">
#admJimsTT {
    .adm-jtt-notes-area {
        margin: 0 !important;
        padding: 10px 15px !important;
        border-top: none;
        border-bottom: none;
        border-left: none;
        font-size: 90% !important;
    }

    .selector-wrapper {
        display: flex;
        flex-wrap: wrap;

        select {
            width: 100%;
        }
    }

     #selectFutureSpreads {
        & > span {
            display: flex;
            flex-wrap: wrap;
        }
        select {
            width: 100%;
        }
     }
     #selectFutureOptions {
        & > div,
        & > div {
            display: flex;
            flex-wrap: wrap;
        }
        select {
            width: auto;
        }
     }
}
</style>
